import Progress from 'rsuite/Progress';
import { COLOURS } from '../styles';

export const ProgressBar = (props) => {
  return (
    <Progress.Line
      percent={props.percentage}
      showInfo={false}
      strokeColor={COLOURS.default} //"#ec4899"
    />
  );
};
